"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var lodash_1 = require("lodash");
var social_networks_1 = tslib_1.__importDefault(require("../../../../constants/social-networks"));
var utils_1 = require("../utils");
var build_url_1 = require("../../../../../common/utils/url/build-url");
var open_popup_1 = tslib_1.__importDefault(require("../../../../../common/utils/open-popup"));
var tooltip_1 = tslib_1.__importDefault(require("../../../../ui-components/tooltip/tooltip"));
var inline_icon_1 = tslib_1.__importDefault(require("../../../../ui-components/inline-icon/inline-icon"));
var styles_scss_1 = tslib_1.__importDefault(require("../styles.scss"));
var TumblrIcon_1 = tslib_1.__importDefault(require("../../../../../icons/compiled/components/TumblrIcon"));
var Tumblr = /** @class */ (function (_super) {
    tslib_1.__extends(Tumblr, _super);
    function Tumblr() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            var siteUrl = _this.props.instanceInfo.siteUrl;
            var _a = _this.props, descriptionText = _a.descriptionText, canShareContent = _a.canShareContent, content = _a.content;
            if (canShareContent) {
                var url = (0, build_url_1.buildUrl)('https://www.tumblr.com/widgets/share/tool', {
                    posttype: 'photo',
                    // todo: need to find a way to resize image for tumblr
                    content: (0, utils_1.buildImageUrl)(content.coverUrl),
                    caption: descriptionText
                        .replace('{siteUrl}', siteUrl)
                        .replace('{title}', content.title),
                    url: siteUrl,
                });
                (0, open_popup_1.default)(url);
            }
            _this.props.onShare(social_networks_1.default.TUMBLR);
        };
        return _this;
    }
    Tumblr.prototype.render = function () {
        var _a = this.props, className = _a.className, dataHook = _a.dataHook, ariaLabel = _a.ariaLabel, tooltip = _a.tooltip;
        return (react_1.default.createElement(tooltip_1.default, { content: tooltip },
            react_1.default.createElement("button", { onClick: this.onClick, "data-hook": dataHook, className: className, "aria-label": ariaLabel },
                react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(TumblrIcon_1.default, null), className: styles_scss_1.default.icon }))));
    };
    Tumblr.propTypes = {
        dataHook: prop_types_1.default.string,
        onShare: prop_types_1.default.func,
        content: prop_types_1.default.object,
        className: prop_types_1.default.string,
        descriptionText: prop_types_1.default.string,
        tooltip: prop_types_1.default.node,
        canShareContent: prop_types_1.default.bool,
        ariaLabel: prop_types_1.default.string,
        instanceInfo: prop_types_1.default.shape({
            instanceId: prop_types_1.default.string,
            componentId: prop_types_1.default.string,
            sitePageId: prop_types_1.default.string,
            siteUrl: prop_types_1.default.string,
        }),
    };
    Tumblr.defaultProps = {
        onShare: lodash_1.noop,
    };
    return Tumblr;
}(react_1.default.Component));
exports.default = Tumblr;
//# sourceMappingURL=tumblr.js.map